import React from "react";
import css from "./ScriptsBlog.module.css";
import {TextView,Title,BlogView, SectionView} from "Components";


export default function ScriptsBlog(){
    return (
        <BlogView className={css.scriptsblog}>
            <Title>Available Scripts</Title>
            <TextView>in your project root folder, you can run:</TextView>
            <ul className={css.scripts}>
                {statics.scripts.map(({npmcmd,description,options})=>
                    <li key={npmcmd} id={"npm"+npmcmd.replace(/ /g,"")}>
                        <Title className={css.cmdname}>npm {npmcmd}</Title>
                        <TextView>{description}</TextView>
                        {options&&<div className={css.options}>
                            {options.map(option=><SectionView
                                {...option}
                                titleSize={5}
                                key={option.name}
                                title={option.name}
                                text={option.description}
                            />)}
                        </div>}
                    </li>
                )}
            </ul>
        </BlogView>
    )
}

const statics={
    scripts:[
        {
            npmcmd:"start",
            description:`
                starts a Webpack server in development mode by default. 
                @you can view the app through 
                <a href="http://localhost:3000" target="_blank" rel="noopener noreferrer">http://localhost:3000</a> 
                in your browser.
                @The page will refresh when you make changes, and any lint errors will be displayed in the console as well.
            `,
            options:[
                {
                    name:"--env=<env_id>",
                    description:`
                        starts the server in the specified env.
                        @if a dev env is specified, a <b>webpack dev server</b> is started
                        @if a test env is specified, a <b>Phonegap server</b> is started
                    `,
                    cli:{lines:[
                        "npm start -- --env=test",
                        "#shorthand",
                        "npm start -- -t",
                    ]},
                },
                {
                    name:"--port",
                    description:"specifies a server port (default to 3000)",
                    cli:{lines:["npm start -- --port=3333"]},
                },
                {
                    name:"--no-open",
                    description:"prevents browser opening",
                    cli:{lines:["npm start -- --no-open"]},
                },
            ],
        },
        {
            npmcmd:"test",
            description:`
                runs End-to-end tests using <b>cypress</b> which comes pre-configured with vritra-scripts
                starting with version <b>1.4.0</b>
                @tests should be located in a <b>tst</b> folder at the app project root directory
            `,
            options:[
                {
                    name:"--env=<env_id>",
                    description:`
                        specifies which env the tests should be run in
                        @tests are run in <b>test mode</b> by default.
                    `,
                },
                {
                    name:"--gui",
                    description:`opens cypress graphical UI`,
                },
            ],
        },
        {
            npmcmd:"run watch",
            description:"watches the src folder and updates the content of the www folder accordingly.",
            options:[{
                name:"--env=<env_id>",
                description:`
                    Used to watch the app in a specific environment:
                    @--env=dev : development (default)
                    @--env=test : testing
                    @--env=prod : production
                `,
                cli:{lines:["npm run watch"]},
            }],
        },
        {
            npmcmd:"run build",
            description:`
                Builds the app to the <b>www</b> folder. 
                @In production mode, it optimizes and minifies files for the best performance.
            `,
            options:[{
                name:"--env=<env_id>",
                description:`
                    Used to build the app in a specific environment:
                    @--env=prod : production (default)
                    @--env=test : testing
                    @--env=dev : development
                `,
                cli:{lines:[
                    "npm run build -- --env=dev",
                    "#shorthand",
                    "npm run build -- -d",
                ]},
            }],
        },
        {
            npmcmd:"run extract",
            description:`
                If the default configuration is not enough and customization via 
                a <b>vritra.config.js</b> file still does not suit your needs, 
                you can extract the default configuration files.
                @this command will add the config files to your app root folder if none
                exists and does nothing else. 
                @you can then remove the <b>vritra-scripts</b>
                package and install the dev packages required 
                for your custom configuration.
                @to get back to the default vritra configs, just reinstall 
                vritra-scripts again, and reset your project scripts 
                in your package.json file.
            `,
            notice:`
                Be careful when implementing your custom config, some configuration 
                is required to keep your project working and behaving as expected.
            `,
        },
    ],
}
